import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Modal, Select } from 'antd';
import * as actions from '../redux/actions/agents';

class EditAgentProduct extends React.Component {

    state = {
        confirmLoading: false,
    }
    layout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };

    onFinish = async (values) => {
        let agentProduct = {
            id: this.props.agentProduct.id,
            productId: values.product,
            unitPrice: values.unitPrice,
            extraCommission: +values.extraCommission,
        }
        await this.props.onUpdate(this.props.agentId, agentProduct, this.props.token);
        this.setState(prevState => {
            return {
                ...prevState,
                confirmLoading: true,
            }
        });
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    confirmLoading: false,
                }
            });
            this.props.onCloseForm();
        }, 200);
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel = () => {
        this.props.onCloseForm();
    }
    render() {
        let productArr = null;
        let productId = null;
        productArr = this.props.products.filter(product => product.id === this.props.agentProduct.productId);

        for (let i in productArr) {
            productId = productArr[i].id;
        }
        const { Option } = Select;
        let products = this.props.products.map(product => {
            return (
                <Option key={product.id} value={product.id}>{product.name}</Option>
            );
        })
        return (
            <Modal
                title="Edit Agent Product"
                key={this.props.agentProduct.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'edit-agentProduct-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="edit-agentProduct-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        product: productId,
                        unitPrice: this.props.agentProduct.unitPrice,
                        extraCommission: this.props.agentProduct.extraCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="product"
                        label="Product"
                        rules={
                            [{
                                required: true,
                                message: 'Require product',
                            }]
                        }
                    >
                        <Select
                            style={{ width: 180 }}
                        >
                            {products}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="unitPrice"
                        label="Unit Price"
                        rules={[
                            {
                                required: true,
                                message: 'Require unit price!',
                            },

                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="extraCommission"
                        label="Extra commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require extra commission!',
                            },

                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        agentId: state.agents.agentDetail.id,
        visible: state.agents.editAgentProductVisible,
        agentProduct: state.agents.agentProduct,
        products: state.products.products,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeAgentProductEdit()),
        onUpdate: (id, agentProduct, token) => dispatch(actions.updateAgentProduct(id, agentProduct, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditAgentProduct);